import React, { memo } from 'react';
import { Typography } from '@mui/material';

const ListSubTitle = ({ children }) => {
  return (
    <Typography variant={'subtitle1'} gutterBottom component="div"
                className={'subtitle-bigger'}>
      {children}
    </Typography>
  );
};

export default memo(ListSubTitle);
